import config from './config';
import './reducers';

export * from './events';
export * from './util';
export * from './selectors';
export * from './actions';
export { default as configureStore } from './configureStore';
export type { RootState, AppDispatch, AppAction } from './configureStore';
export { useAppDispatch, useAppSelector } from './hooks';
export type { EntitiesState } from './reducers/entities';
export type { ItemsState } from './reducers/items';
export type { RequestState, RequestEntry } from './reducers/request';
export type { SessionState } from './reducers/session';
export type { StreamState } from './reducers/stream';
export { default as config } from './config';

export function use(newConfig: Partial<typeof config>): void {
  Object.assign(config, newConfig);
}
